var upvote = document.querySelector("#upvote");
var downvote = document.querySelector("#downvote");
var roomFinder = document.querySelector("#roomFinder");
var votingContainer = document.querySelector("#votingContainer");
var roomCode = document.querySelector("#roomCode");
var joinButton = document.querySelector("#join");
var room2;
function setup() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("room")) {
        roomCode.value = urlParams.get("room");
    }
    roomCode.oninput = function () {
        var req = new XMLHttpRequest();
        req.open("POST", "/presentinator/api/hostinfo/", true);
        req.setRequestHeader("Content-Type", "application/json");
        req.onreadystatechange = function () {
            if (req.readyState == 4 && req.status == 200) {
                var resp = JSON.parse(req.response);
                joinButton.disabled = resp.code != 0;
            }
        };
        req.send(JSON.stringify({ room: roomCode.value }));
    };
    joinButton.onclick = function () {
        room2 = roomCode.value;
        roomFinder.style.display = "none";
        votingContainer.style.display = "flex";
    };
}
setup();
upvote.onclick = function () {
    var req = new XMLHttpRequest();
    req.open("POST", "/presentinator/api/", true);
    req.setRequestHeader("Content-Type", "application/json");
    req.onreadystatechange = function () {
        if (req.readyState == 4 && req.status == 200) {
            console.log(JSON.parse(req.response).votes);
        }
    };
    req.send(JSON.stringify({ room: room2, vote: 1 }));
};
downvote.onclick = function () {
    var req = new XMLHttpRequest();
    req.open("POST", "/presentinator/api/", true);
    req.setRequestHeader("Content-Type", "application/json");
    req.onreadystatechange = function () {
        if (req.readyState == 4 && req.status == 200) {
            console.log(JSON.parse(req.response).votes);
        }
    };
    req.send(JSON.stringify({ room: room2, vote: -1 }));
};
export {};
